import { lazy, useMemo } from "react";
import { Navigate, type RouteObject } from "react-router";
import { useBerechtigt } from "../../components/Guard";
import ServoTypDetails from "./ServoTypDetails";
import ServoTypDetailsTestszenarios from "./ServoTypDetailsTestszenarios";

const ServoTypListe = lazy(() => import("./ServoTypListe"));

export function useServoTypenRoutes(): Array<RouteObject> {
  const enabled = useBerechtigt({ berechtigung: "servo-typ:liste" });

  return useMemo(
    () =>
      enabled
        ? [
            {
              path: "servo-typen",
              children: [
                {
                  index: true,
                  element: <ServoTypListe />,
                },
                {
                  path: ":servoTypId",
                  element: <ServoTypDetails />,
                  children: [
                    {
                      index: true,
                      element: <Navigate to="testszenarios" replace />,
                    },
                    {
                      path: "daten",
                      element: <ServoTypDetailsTestszenarios />,
                    },
                    {
                      path: "testszenarios",
                      element: <ServoTypDetailsTestszenarios />,
                    },
                  ],
                },
              ],
            },
          ]
        : [],
    [enabled]
  );
}
